export const baseUrl:string = process.env.REACT_APP_NODE_ENV === 'development' ? "http://127.0.0.1:8000/apidashboard/" : "https://magziapp.com/api/"

export const Collection_API = (name:string, limit=8, offset=0) => `collection/get-collection-by-parentcollection/collection=${name}&limit=${limit}&offset=${offset}/`
